function handleHasHiddenTextToggleClassClicked(caller = null)
{
  let actionContainers = jQuery(".action-click-container .action-container .action-one");
  let actionContainersLength = actionContainers.length;
  let i = 1;
  let changedClass = false;
  if (!actionContainersLength)
  {
    actionContainersLength = 0;
  }
  if (actionContainersLength > 0)
  {
    Object.keys(actionContainers).forEach(actionContainer =>
    {
      if (i > Number(actionContainersLength))
      {
        return;
      }
      // let hiddenTextContainer = jQuery(actionContainers[actionContainer]).closest('.has-hidden-text');
      if (jQuery(actionContainers[actionContainer]).hasClass('show'))
      {
        jQuery(actionContainers[actionContainer]).removeClass('show');
        if (caller == actionContainers[actionContainer])
        {
          changedClass = true;
        }
      }
      i++;
    });
  }
  return changedClass;
}


/* Scroll to anchor */
function pgshow(e)
{
    var elId = window.location.hash;
    if (elId.length > 1)
    {
        let el = document.getElementById(elId.substr(1));
        if (el) el.scrollIntoView(true);
    }
}
window.pgshow = pgshow;

window.addEventListener("pageshow", pgshow);


/* Share popup function */

function zw_social_share(data) {
  window.open(
    data,
    "Share",
    "height=500,width=760,top=" +
      (jQuery(window).height() / 2 - 250) +
      ", left=" +
      (jQuery(window).width() / 2 - 380) +
      "resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0"
  );
}
window.zw_social_share = zw_social_share;

function zw_show_rating_stars(trigger) {
  jQuery(trigger)
    .next(".rmp-rating-widget__icons-list")
    .removeClass("d-none")
    .addClass("d-flex");
  jQuery(trigger).addClass("d-none");
}
window.zw_show_rating_stars = zw_show_rating_stars;

function zw_hide_rating_after_rate(trigger) {
  console.log(trigger);
  jQuery(trigger.currentTarget)
    .closest(".js-rmp-rating-widget")
    .delay(2000)
    .queue(function () {
      jQuery(this).addClass("d-none").dequeue();
    });
}
window.zw_hide_rating_after_rate = zw_hide_rating_after_rate;
// function zw_mb_append_sticky_to_main_nav_on_scroll(e)
// {
//   const header = document.querySelector('.mainHeader');
//   const main = document.querySelector('.main');
//   const pageName = document.querySelector('.pageName');

//   // Get the height of the header
//   const headerOffsetHeight = header.offsetHeight;

//   // Apply the height as padding-top to the main element
//   const stickyPoint = header.offsetTop;

//   const headerBottom = header.getBoundingClientRect().bottom;
//   const mainTop = main.getBoundingClientRect().top;
//   if (window.scrollY > stickyPoint && mainTop === headerBottom){
//     header.classList.add('sticky');
//     main.style.paddingTop = `${header.offsetHeight - (0.1 * header.offsetHeight) }px`;
//   }
//   else if (mainTop > 0)
//   {
//     header.classList.remove('sticky');
//     main.style.paddingTop = `0px`;
//   } else if (window.scrollY > stickyPoint){
//     header.classList.add('sticky');
//     main.style.paddingTop = `${header.offsetHeight - (0.1 * header.offsetHeight)}px`;
//   } else
//   {
//     header.classList.remove('sticky');
//     main.style.paddingTop = `0px`;
//   }
// }

function zw_mb_append_sticky_to_main_nav_on_scroll()
{
  const header = document.querySelector('.mainHeader');
  const main = document.querySelector('.main');

  // 👇 configurable scroll threshold
  const STICKY_SCROLL_OFFSET = 35;

  // Current scroll position
  const scrollY = window.scrollY;

  if (scrollY > STICKY_SCROLL_OFFSET)
  {
    if (!header.classList.contains('sticky'))
    {
      header.classList.add('sticky');

      // Add spacing to prevent jump
      main.style.paddingTop = `${header.offsetHeight * 0.9}px`;
    }
  } else
  {
    if (header.classList.contains('sticky'))
    {
      header.classList.remove('sticky');
      main.style.paddingTop = `0px`;
    }
  }
}
window.zw_mb_append_sticky_to_main_nav_on_scroll = zw_mb_append_sticky_to_main_nav_on_scroll;
jQuery(document).ready(function () {
  window.setTimeout(() => {
    window.addEventListener('scroll', zw_mb_append_sticky_to_main_nav_on_scroll);
  }, 100);
  zw_mb_append_sticky_to_main_nav_on_scroll();
  jQuery(".action-click-container .action-container .action-one").click(function (e)
  {
    const changedClass = handleHasHiddenTextToggleClassClicked(this);
    if (!changedClass)
    {
      jQuery(this).toggleClass('show');
    }
  });

  jQuery(".zw-toggle-sidebar").click(function (e)
  {
    jQuery(this).toggleClass('zw-x');
    jQuery(this).closest('.zw-sidebar').toggleClass('opened');
    jQuery(this).closest('.zw-sidebar').find('.zw-sidebar-content').toggleClass('show');
  });

  // document.querySelectorAll('p, h1, h2, h3, h4, h5, h6').forEach(element =>
  // {
  //   if (element.textContent.trim() === '' || element.innerHTML === '&nbsp;')
  //   {
  //     element.classList.add('nbsp');
  //   }
  // });

  //replace labels and placeholders in listings plugin
  jQuery(document).ready(function ($)
  {
    $('#classiwrapper label').each(function ()
    {
      var label = $(this);
      var input = $('#' + label.attr('for'));
      if (input.length > 0)
      {
        input.attr('placeholder', label.text());
        label.hide(); // Optionally hide the label if not needed
      }
    });
  });

});

/**
 * On Resize
 */
jQuery(window).resize(function () {

});

jQuery(document).click(function (event)
{
  let container = jQuery(".action-click-container .action-container");
  if (!container.is(event.target) && !container.has(event.target).length)
  {
    handleHasHiddenTextToggleClassClicked();
  }
});

/* Sidebar navigation link trigger */
jQuery(function($){
    $(document).on("click", "a[href='#sidebarnavigation']", function(e) {
        e.preventDefault();
        $(".zw-toggle-sidebar").trigger("click");
    });
});

// // Owl Carousel initialization and fix for refresh issue
// jQuery(window).on('load', function () {
//   console.log("load Triggered");
// 	setTimeout(function () {
//      console.log("after 500ms Timeout Triggered");

// 		jQuery('.owl-carousel').each(function () {
// 			var $carousel = jQuery(this);

// 			$carousel.trigger('refresh.owl.carousel');

// 			window.dispatchEvent(new Event('resize'));
// 		});
// 	}, 500);
// });

